import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import {ClientteamServiceService} from '../clientteam-service/clientteam-service.service';
import {ToastrService} from 'ngx-toastr';
import {ClientServiceService} from '../../client/client-service/client-service.service';

@Component({
  selector: 'app-clientteam-form',
  templateUrl: './clientteam-form.component.html',
  styleUrls: ['./clientteam-form.component.css']
})
export class ClientteamFormComponent implements OnInit {
  clientContactForm: FormGroup;
  cId: any;
  clientId: any;
  client: any
  loading: boolean;
  submitted: boolean;
  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _formBuilder: FormBuilder,
              private _clientTeamService: ClientteamServiceService,
              private clientService: ClientServiceService,
              private toastr: ToastrService) {

    this._route.params.subscribe(routeParams => {this.clientId = routeParams.clientIdParam; });
    this.clientId = this.clientId !== undefined ? this.clientId : localStorage.getItem('clientId');
    this.client = this.getClientDetails(this.clientId);
    this.clientContactForm = this._formBuilder.group({
    firstName: ['', Validators.required],
    lastName: [''],
    phoneNumberCell: [''],
    phoneNumberOffice: [''],
    email: ['', Validators.required],
    userType: ['PHYSICIAN', Validators.required]
    });
  }

  ngOnInit() {
  }

  saveClientContact(clientContactForm) {
    console.log(clientContactForm.value);
    this.loading = true;
    this.submitted = true;
    this._clientTeamService.addUpdateClientContact(clientContactForm.value, this.clientId)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Client saved successfully');
            //this._router.navigate(['/elasticcare/clientcontacts']);
            this._router.navigate( [ '/elasticcare/clientcontacts' ], { fragment: this.clientId } );
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }

  public getClientDetails(clientId: any) {
    this.clientService.getClientById(clientId)
        .pipe(first())
        .subscribe(data => {
          console.log('client ::' + data.json())
          this.client = data.json();
        }, (error) => {
          this.toastr.error('', 'Please try again');
        });
  }


}
